// components/BlogRecentPost.js
import BlogFeaturedImage from './BlogFeaturedImage'
import Link from 'next/link'
import { generateBlogPostLink } from '../helpers/utils'
import { isObject } from 'lodash'
import BlogDateInline from './BlogDateInline'
// import BlogTagsBlock from './BlogTagsBlock'

export const BlogRecentPost = ({
    post,
    image = 'normal',
    viewStyle = 'vertical',
    isSidePosts = false,
}) => {
    // const imageHeight =
    //     image === 'small' ? 'h-20' : image === 'medium' ? 'h-40' : 'h-60'

    return (
        <div
            className={`bg-transparent rounded-lg overflow-hidden ${
                viewStyle === 'horizontal' ? 'flex items-start' : ''
            }`}>
            {viewStyle === 'horizontal' && (
                <div className={'relative w-20 pr-2'}>
                    <BlogFeaturedImage post={post} size={image} />
                </div>
            )}

            {viewStyle === 'vertical' && (
                <div className={'relative w-full bg-gray-200 mb-2 h-28'}>
                    <BlogFeaturedImage post={post} size="medium" />
                </div>
            )}
            <div
                className={`p-1 space-y-2 ${
                    viewStyle === 'horizontal' ? 'w-3/4' : ''
                }`}>
                <h2>
                    <Link href={generateBlogPostLink(post)}>
                        <a
                            className={
                                'block mt-2 text-base font-light text-blog-black hover:text-olh'
                            }>
                            {isObject(post.title)
                                ? post.title.rendered
                                : post.post_title}
                        </a>
                    </Link>
                </h2>
                <div
                    className={'text-xs uppercase tracking-wide text-gray-bbb'}>
                    <BlogDateInline post={post} isSidePosts={isSidePosts} />
                </div>
                {/* <BlogTagsBlock post={post} /> */}
            </div>
        </div>
    )
}
